import { render } from "./PubRedirect.vue?vue&type=template&id=40c18282&scoped=true"
import script from "./PubRedirect.vue?vue&type=script&lang=js"
export * from "./PubRedirect.vue?vue&type=script&lang=js"

import "./PubRedirect.vue?vue&type=style&index=0&id=40c18282&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c18282"]])

export default __exports__